import { useEffect, useState } from 'react';
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

import { useAssistant } from '@core/assistant/providers/Provider';
import { useStyles } from './styles';

interface IDebugFlowSelectorProps {
  onStartFlow: (flowId: string) => void;
}

const DebugFlowSelector = ({ onStartFlow }: IDebugFlowSelectorProps) => {
  const classes = useStyles();
  const { scripts } = useAssistant();

  const [selectedFlow, setSelectedFlow] = useState('');

  useEffect(() => {
    if (scripts.length > 0 && !selectedFlow) {
      const triggers = Array.isArray(scripts[0].scriptTrigger)
        ? scripts[0].scriptTrigger
        : [scripts[0].scriptTrigger];
      const spotRegionTrigger = triggers.find((t) =>
        t.toLowerCase().startsWith('spotregion'),
      );
      setSelectedFlow(spotRegionTrigger ?? triggers[0]);
    }
  }, [scripts]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedFlow(event.target.value);
  };

  return (
    <>
      <FormControl fullWidth sx={classes.debugSelect}>
        <Select value={selectedFlow} onChange={handleChange}>
          {scripts.map((script) => {
            const triggers = Array.isArray(script.scriptTrigger)
              ? script.scriptTrigger
              : [script.scriptTrigger];
            const spotRegionTrigger = triggers.find((t) =>
              t.toLowerCase().startsWith('spotregion'),
            );
            const trigger = spotRegionTrigger ?? triggers[0];
            const stripped = trigger.replace(/^SpotRegion_/i, '');
            const label = stripped.charAt(0).toUpperCase() + stripped.slice(1);
            return (
              <MenuItem key={script.scriptId} value={trigger}>
                {label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <Button
        sx={{ ...classes.debugButton, ...classes.debugStartFlowButton }}
        onClick={() => onStartFlow(selectedFlow)}
        disabled={!selectedFlow}
      >
        Start selected flow
      </Button>
    </>
  );
};

export default DebugFlowSelector;
